import { useState } from 'react'
import { SortsConfigType, SortsType } from '../types/advanced-grid.types'

type HandleChangeType = (s: string) => void

/**
 * Hook to allow the grid control the sorts
 * @param sorts
 * @returns
 */
const useSorter = (sorts: SortsConfigType): [SortsType, HandleChangeType] => {
    const [sortValues, setSortValues] = useState<SortsType>(
        (sorts || []).reduce((a, c) => {
            a[c] = 0
            return a
        }, {})
    )

    const handleChangeSort = (sortName: string) => {
        const currentValue = sortValues[sortName]
        let newValue = 0
        if (currentValue === 0) {
            newValue = 1
        } else if (currentValue === 1) {
            newValue = -1
        }
        setSortValues({
            ...sortValues,
            [sortName]: newValue
        })
    }
    return [sortValues, handleChangeSort]
}

export default useSorter
